import { render } from "./ContactView.vue?vue&type=template&id=95a42ec4"
const script = {}

import exportComponent from "/home/runner/work/an-website/an-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__